module.exports = __webpack_public_path__ + "static/media/viposterLogo_lightBG.1c998803.svg";